import React, { useState, useContext } from 'react'
import { NavLink, Route, Redirect } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { LoginContext } from '../../context/LoginContext';

const Navigation = () => {

    const { removeToken } = useContext(LoginContext);
    
    const [ anchorEl, setAnchorEl ] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    const handleLogout = () => {
        const data = {
            token: localStorage.getItem('token')
        }
        removeToken(data);
    }

    return (
        <>
            <Route exact path="/">
                {localStorage.getItem('token') ? <Redirect to="/" /> : ""}
            </Route>
            <Box mb={4}>
                <Box p={1}>
                    <Button
                        aria-owns={anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup="true"
                        onClick={handleMenuOpen}
                        variant="contained" color="primary"
                    >
                        Navigation
                    </Button>
                    <Button variant="outlined" color="primary" style={{float: "right"}} onClick={handleLogout}> Log out</Button>
                </Box>
                <Divider />
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    <MenuItem onClick={handleMenuClose}>
                        <NavLink to="/references">Reference</NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose}>
                        <NavLink to="/photos">Photos</NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose}>
                        <NavLink to="/translations">Translation Keys</NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose}>
                        <NavLink to="/contact-forms">Contact Forms</NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose}>
                        <NavLink to="/reference-add">+ Reference</NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose}>
                        <NavLink to="/photo-add">+ Photo</NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose}>
                        <NavLink to="/translation-add">+ Translation Key</NavLink>
                    </MenuItem>
                </Menu>
            </Box>
        </>
    )
}

export default Navigation
